import { render, staticRenderFns } from "./ProcesosPorComprar.vue?vue&type=template&id=82231c40&scoped=true"
import script from "./ProcesosPorComprar.vue?vue&type=script&lang=js"
export * from "./ProcesosPorComprar.vue?vue&type=script&lang=js"
import style0 from "./ProcesosPorComprar.vue?vue&type=style&index=0&id=82231c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82231c40",
  null
  
)

export default component.exports